// extracted by mini-css-extract-plugin
module.exports = {"changelog-page":"ChangelogPage-changelog-page--fIspP","body-section":"ChangelogPage-body-section--uFZeX","notice-section":"ChangelogPage-notice-section--1ByZB"};